import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authSlice } from './auth';

export interface AutomationFormState {
  formData: Record<string, any>;
}

// Initialize with data from localStorage if available
const getInitialState = (): AutomationFormState => {
  try {
    const storedData = localStorage.getItem('automationFormData');
    return {
      formData: storedData ? JSON.parse(storedData) : {},
    };
  } catch (error) {
    console.error('Failed to parse stored automation form data', error);
    return { formData: {} };
  }
};

const initialState: AutomationFormState = getInitialState();

export const automationFormSlice = createSlice({
  name: 'automationForm',
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<Record<string, any>>) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
      // Save to localStorage
      localStorage.setItem('automationFormData', JSON.stringify(state.formData));
    },
    resetForm: (state) => {
      state.formData = {};
      localStorage.removeItem('automationFormData');
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authSlice.actions.logout, (state) => {
      state.formData = {};
      localStorage.removeItem('automationFormData');
    });
  },
});

export const { updateFormData, resetForm } = automationFormSlice.actions;

export default automationFormSlice.reducer;
